export const isG2Redirect = (approvingModelID, aprString) => {
  const aprDecimal = aprString?.includes('.') ? aprString.split('.').pop() : null
  return approvingModelID === '1' && aprDecimal === '95'
}

export const isAvant = approvingModelID => {
  return approvingModelID !== '2'
}

export const determineRedirectAndKeyword = landingKeyword => {
  let g2Redirect = false
  let keyword = landingKeyword
  if (landingKeyword === 'creditkarma_lbfl') {
    const windowSearchUrl = window.location.search
    const searchParams = new URLSearchParams(windowSearchUrl)
    const approvingModelID = searchParams.get('approvingmodelid')
    const aprString = searchParams.get('apr')
    if (isG2Redirect(approvingModelID, aprString)) g2Redirect = true
    if (isAvant(approvingModelID)) keyword = 'creditkarma_lbpa'
  }
  return [g2Redirect, keyword]
}

export const showXSellDisclosure = () => {
  const windowSearchUrl = window.location.search
  const searchParams = new URLSearchParams(windowSearchUrl)
  if (searchParams.size < 2) {
    return false
  }

  const approvingModelID = searchParams.get('approvingmodelid')
  const aprDecimal = searchParams.get('apr')
  return isG2Redirect(approvingModelID, aprDecimal)
}

export const isCreditKarmaPage = () => {
  return (
    window.location.pathname === '/personal-loans/landing/creditkarma_lbfl/' ||
    window.location.pathname === '/personal-loans/landing/creditkarma_lbfl'
  )
}
